import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import GrnForRejStock from "../components/grnForRejStock";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const ItemVIewReport = () => {
   useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedItemCode, setSelectedItemCode] = useState(null);

  const canView  = hasPermission("Item Master", "view");
  const canEntry  = hasPermission("Item Master", "entry");

  useEffect(() => {
    fetchData();
  }, [branch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemMaster_list?branch=${branch}`);
      setData(response.data.itemList);
      setFilteredData(response.data.itemList);
    } catch (error) {
      console.error("Error fetching itemList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    console.log("Search term:", term);
    console.log("Data before filtering:", data);
  
    if (!data || data.length === 0) {
      console.warn("Data is empty or undefined");
      return;
    }
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>    
      (item.itemmaster_code?.toString().toLowerCase().includes(term) ||
       item.itemmaster_name?.toString().toLowerCase().includes(term))
    );
  
    
    setFilteredData(filtered);
  };
   // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Item Master - Report</h2>
          <Time />
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Item Name or Code"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Item Code</th>
                <th>Part No.</th>
                <th>Item Name</th>
                <th>Location</th>
                {/* <th>Opening Stock</th> */}
                <th>Closing Stock</th>
                <th>Rejected Closing Stock</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
<td>
  {canEntry ? (
    <Link to={`/inventory/list_Itemserialnumber/${item.itemmaster_code}`}>
      {item.itemmaster_code}
    </Link>
  ) : (
    item.itemmaster_code
  )}
</td>

                  
                    <td>{item.itemmaster_drawingNumber}</td>
                    <td>{item.itemmaster_name}</td>
                    <td>{item.itemmaster_location}</td>
                    {/* <td>{item.itemmaster_openingStock}</td> */}
                    <td>{item.itemmaster_closingStock}</td> 
                    <td
  style={{
    color: item.itemMaster_rejStock && item.itemMaster_rejStock > 0 ? "red" : "black",
    cursor: item.itemMaster_rejStock && item.itemMaster_rejStock > 0 ? "pointer" : "default",
    fontWeight: item.itemMaster_rejStock && item.itemMaster_rejStock > 0 ? "bold" : "normal",
  }}
  onClick={() => {
    if (item.itemMaster_rejStock && item.itemMaster_rejStock > 0) {
      setSelectedItemCode(item.itemmaster_code);
      setShowModal(true);
    }
  }}
>
  {item.itemMaster_rejStock && item.itemMaster_rejStock > 0 ? item.itemMaster_rejStock : "-"}
</td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>

        <GrnForRejStock
  showModal={showModal}
  closeModal={() => setShowModal(false)}
  branch={branch}
  itemcode={selectedItemCode}   // ✅ pass itemcode
/>
    </div>
  );
};

export default ItemVIewReport;
